export const LogoMark = ({ className = "", draw = false }) => (
  <svg viewBox="0 0 64 52" className={`${className} ${draw ? "logo-draw" : ""}`} fill="none" aria-hidden="true">
    <g stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 36 L27 34.5 L28.5 10 Q29 6 33 6 L52 6 Q57 6 58 11 L61 42" />
      <path d="M16 42 L36 42 Q37.5 36 42 36 Q46.5 36 48 42 L61 42" />
    </g>
  </svg>
);

export const Logo = ({ className = "", testid = "brand-logo" }) => (
  <span data-testid={testid} className={`flex items-center gap-2.5 ${className}`}>
    <LogoMark className="h-7 w-auto text-white" draw />
    <span className="font-display text-2xl font-black italic leading-none tracking-tight text-white">TRANSCARS</span>
  </span>
);
